import { AccountStatus } from '@hungryroot/customer';
import {
  useNextOrderV2,
  usePollGetOrderNotShuffling,
} from '@hungryroot/orders';
import { useCustomerSelf } from '../../../../api/v2/customers/self/get/get-customer-self';
import { getAccountStatus } from '../Banner/utils';

export enum AddRemoveAction {
  Add = 'add',
  Remove = 'remove',
}

export function useAddToCartModal(): {
  accountStatus: AccountStatus | undefined;
  orderId: number | undefined;
  isActive: boolean;
  isLoading: boolean;
} {
  const customerQuery = useCustomerSelf();
  const { data: customerData } = customerQuery;
  const useNextOrderResult = useNextOrderV2();
  const { order } = useNextOrderResult;
  const orderId = order?.id;

  const { data: nextCustomizableOrder } = usePollGetOrderNotShuffling({
    orderId,
  });

  const accountStatusData = customerData
    ? getAccountStatus(customerData, nextCustomizableOrder)
    : undefined;
  const { accountStatus } = accountStatusData || {};

  return {
    accountStatus,
    orderId,
    isLoading:
      nextCustomizableOrder === undefined || customerData === undefined,
    isActive:
      accountStatus !== undefined && accountStatus !== AccountStatus.Active,
  };
}
